import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MarkantElementsModule } from '@markant/elements-angular';
import { EditSuborganizationsRoleAssignmentFlow } from '@markant-platform/shared/authorizer/model';

@Component({
  selector: 'markant-platform-ui-cartridge-roles-assignment-item',
  standalone: true,
  imports: [MarkantElementsModule],
  templateUrl: './ui-cartridge-roles-assignment-item.component.html',
  styleUrl: './ui-cartridge-roles-assignment-item.component.scss',
})
export class UiCartridgeRolesAssignmentItemComponent {
  @Input({ required: true }) suborganizationName!: string;
  @Input() isSelected = false;
  @Input() isClickable = false;
  @Input() isOverallResponsibility = false;

  @Input({ required: true }) flow!: EditSuborganizationsRoleAssignmentFlow;

  @Output() added = new EventEmitter<void>();
  @Output() removed = new EventEmitter<void>();

  readonly editSuborganizationsRoleAssignmentFlow = EditSuborganizationsRoleAssignmentFlow;
}
